/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free ideal weight calculator. Find the healthy weight range for your height based on a normal BMI (18.5–24.9), in kg or pounds.`)
};

const es_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de peso ideal gratuita. Encuentra el rango de peso saludable para tu altura basado en un IMC normal (18,5–24,9), en kg o libras.`)
};

const de_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Idealgewicht-Rechner. Finden Sie den gesunden Gewichtsbereich für Ihre Größe basierend auf einem normalen BMI (18,5–24,9), in kg oder Pfund.`)
};

const nl_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis ideaal gewichtsrekenmachine. Zoek het gezonde gewichtsbereik voor uw lengte op op basis van een normale BMI (18,5–24,9), in kg of ponden.`)
};

const fr_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de poids idéal gratuit. Trouvez la plage de poids santé pour votre taille en fonction d'un IMC normal (18,5-24,9), en kg ou en livres.`)
};

const it_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore peso ideale gratuito. Trova l'intervallo di peso sano per la tua altezza basato su un BMI normale (18,5–24,9), in kg o libbre.`)
};

const pt_br2_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de peso ideal. Encontre a faixa de peso saudável para sua altura com base em um IMC normal (18,5–24,9), em kg ou libras.`)
};

const pt_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de peso ideal gratuita. Encontre o intervalo de peso saudável para a sua altura com base num IMC normal (18,5–24,9), em kg ou libras.`)
};

const ja_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の理想体重計算機。正常なBMI（18.5～24.9）に基づいて身長の健康的な体重範囲をkg またはポンドで確認できます。`)
};

const zh_hw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费理想体重计算器。根据正常 BMI 范围（18.5–24.9），以千克或磅为单位，找到您身高对应的健康体重范围。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_meta_description", locale)
	if (locale === "en") return en_hw_meta_description(inputs)
	if (locale === "es") return es_hw_meta_description(inputs)
	if (locale === "de") return de_hw_meta_description(inputs)
	if (locale === "nl") return nl_hw_meta_description(inputs)
	if (locale === "fr") return fr_hw_meta_description(inputs)
	if (locale === "it") return it_hw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_hw_meta_description(inputs)
	if (locale === "pt") return pt_hw_meta_description(inputs)
	if (locale === "ja") return ja_hw_meta_description(inputs)
	return zh_hw_meta_description(inputs)
};